<div id="searchBar"> 
  <input type="button" class="button is-link is-light" value="Search" (click)="btnClicked()" (touchstart)="initiateKeyboard()" #searchBarButton>
</div>

<div class="box modal-container" [ngClass]="{'is-active': showModal}"
[@openClose]="animateModal ? 'open' : 'closed'"
(@openClose.done)="onAnimationEnded()">
  <form (submit)="onFormSubmit($event)">
    <div class="control has-icons-right ">

      <input
        id="searchBarInput"
        type="text"
        placeholder="Enter Search term and hit Enter..."
        class="input"
        (input)="term = $event.target.value"
        [value]="term"
        #searchBarInput
      />
      <span (click)="clearTerm()" *ngIf="term" class="icon is-small is-right is-action">
        <i class="fas fa-times-circle"></i>
      </span>      
    </div>
  </form>
</div>
